@if (isNavigating()) {
  <app-in-navigation-placeholder />
}
<router-outlet></router-outlet>
<app-idle-watch></app-idle-watch>
